import ManageGroupCtrl from '../groups/ManageGroupCtrl';
import { groupTexts } from '../constants';

import manageGroupUrl from './manageTag.html';

class ManageTagCtrl extends ManageGroupCtrl {
  constructor(
    Authentication,
    TagsService,
    ConfirmService,
    Utils,
    Groups,
    PersonaCollection,
    Restangular,
    AlertService,
    UserUtils,
    $timeout,
    $state,
    $location,
    $sce,
    $uibModal,
    focus,
    uppercaseFirstFilter
  ) {
    'ngInject';

    super(
      ConfirmService,
      Utils,
      Groups,
      PersonaCollection,
      Restangular,
      AlertService,
      UserUtils,
      $timeout,
      $state,
      $location,
      $sce,
      $uibModal,
      focus,
      uppercaseFirstFilter
    );
    Object.assign(this, { Authentication, Restangular, TagsService });
  }

  $onInit() {
    this.group = this.tag;
    this.originalGroup = this.Restangular.copy(this.tag);
  }

  async submit() {
    this.error = false;
    if (this.form.$invalid) {
      this.form.$setSubmitted();
      return;
    }

    delete this.tag.members;
    try {
      await this.TagsService.saveTag(this.tag);
      if (this.tag.id) {
        this.originalGroup = this.PersonaCollection.tags.find((tag) => tag.id === this.tag.id);
        return this._successSave();
      }

      return this._goBack();
    } catch (error) {
      return this._failure(error);
    }
  }

  cancel() {
    super.cancel();
    this.tag = this.group;
  }

  async delete() {
    const config = {
      question: groupTexts.tag.singleDeletion.title,
      warning: 'Warning: this cannot be undone.',
      title: 'Delete tag',
      conditions: groupTexts.tag.singleDeletion.conditions,
      confirm: 'Delete',
    };

    await this.ConfirmService.ask(config);
    this.error = false;

    try {
      await this.TagsService.deleteTag(this.tag);
      this._deleteSuccess();
    } catch (error) {
      this._failure(error);
    }
  }
}

export default {
  controller: ManageTagCtrl,
  controllerAs: 'ctrl',
  templateUrl: manageGroupUrl,
  bindings: {
    tag: '<',
    previousState: '<',
  },
};
